export enum AdminPanelPermissionsModalType {
    NONE = 0,
    WARN_ADMIN = 1,
}
